import {lazy} from 'react';

const BenefitsAnalysis = lazy(() => import('./BenefitsAnalysis'));
const ClientManagement = lazy(() => import('./ClientManagement'));
const StrategySandbox = lazy(() => import('./StrategySandbox'));
const PageNotFound = lazy(() => import('./Error/PageNotFound'));
const ServerError = lazy(() => import('./Error/ServerError'));

export default {
    BenefitsAnalysis,
    ClientManagement,
    StrategySandbox,
    PageNotFound,
    ServerError
};
